import { switchMap, take } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod';
import { dataAccessEnvironment } from '../../models/data-access-environment';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { postJwt } from '../authws/post-jwt';
import { routingProfileServiceEnvironment } from './routing-profile-service-environment';
import { routingProfileSchema } from './schemas/routing-profile.schema';

export function getRoutingProfilesId(routingProfileId: number) {
  return postJwt({ authenticationToken: dataAccessEnvironment.authToken }).pipe(
    take(1),
    switchMap((jwt) => {
      return fromFetch(
        new Request(
          `${routingProfileServiceEnvironment.routingProfilesUrl}/${routingProfileId}`,
          {
            method: 'GET',
            headers: {
              ...requiredHeaders,
              Authorization: `bearer ${jwt.access_token}`,
            },
          }
        )
      ).pipe(
        selectData(
          z.object({
            data: routingProfileSchema,
          })
        )
      );
    })
  );
}
